export const brl = (n) =>
  Number(n || 0).toLocaleString("pt-BR", { style: "currency", currency: "BRL" });

export const dateBR = (iso) => {
  if (!iso) return "-";
  const d = new Date(iso);
  return d.toLocaleDateString("pt-BR");
};

export const timeBR = (iso) => {
  if (!iso) return "-";
  return new Date(iso).toLocaleTimeString("pt-BR", { hour: "2-digit", minute: "2-digit" });
};

export const PLANS_INFO = {
  free: { name: "Grátis", price: 0, tone: "stone" },
  essencial: { name: "Essencial", price: 39.9, tone: "amber" },
  profissional: { name: "Profissional", price: 79.9, tone: "orange" },
  master: { name: "Master", price: 149.9, tone: "emerald" },
};

export const STATUS_LABELS = {
  recebido: "Recebido",
  confirmado: "Confirmado",
  preparando: "Preparando",
  pronto: "Pronto",
  saiu: "Saiu p/ entrega",
  entregue: "Entregue",
  cancelado: "Cancelado",
};

export const STATUS_TONES = {
  recebido: "bg-blue-50 text-blue-700 border-blue-200",
  confirmado: "bg-sky-50 text-sky-700 border-sky-200",
  preparando: "bg-amber-50 text-amber-700 border-amber-200",
  pronto: "bg-emerald-50 text-emerald-700 border-emerald-200",
  saiu: "bg-violet-50 text-violet-700 border-violet-200",
  entregue: "bg-stone-100 text-stone-700 border-stone-200",
  cancelado: "bg-rose-50 text-rose-700 border-rose-200",
};
